 import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import { ClientEntity, JaarrapportageEntity, ToelichtingenJaarrekening } from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst',
  templateUrl: './tekst.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ],
  styleUrls: ['./tekst.component.scss']
})
export class TekstComponent implements OnInit {

  @Input() public id!: string;
  public textFg = <FormGroup>{};
  public client = <ClientEntity>{};
  public JaarrapportageEntity = <JaarrapportageEntity>{};
  public year: number | undefined = <number>{};

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private fb: FormBuilder) {
    this.textFg = this.fb.group<ToelichtingenJaarrekening>({
      samenStellingVerklaring: null as unknown as string,
    })
  }

  ngOnInit(): void {
    this.algDataService.client.subscribe((value) => {
      this.client = value;
    });
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.JaarrapportageEntity = value;
      this.year = value.year;

    });
  }

  saveForm(): void {
    const updatedEntity= {
      ...this.JaarrapportageEntity,
    } as JaarrapportageEntity;
    this.jrDataService.updateEntity(updatedEntity);
  }
}
